import React from "react";
import WidgetSkeleton from "../widget/WidgetSkeleton";
import { formatNumber, formatPercentage } from "../../utils/formatter";

interface PerfData {
  total_awb: number;
  exeed_awb: number;
  meet_awb: number;
  onprocess_awb: number;
  percentages_exeed: string;
  percentages_meet: string;
  percentages_onprogress: string;
}
interface Section5Props {
  delivery: PerfData | null;
  pickup: PerfData | null;
  isLoadingDelivery: boolean;
  isLoadingPickup: boolean;
}

const Section5: React.FC<Section5Props> = ({
  delivery,
  pickup,
  isLoadingDelivery,
  isLoadingPickup,
}) => {
  return (
    <div className="row mb-3">
      <div className="mb-2 col-12 col-lg-6">
        <div className="card bg-white p-4" id="DELIVERY-PERFORMANCE">
          {isLoadingDelivery && <WidgetSkeleton />}
          <div className="row">
            <div className="col-12 mb-2">
              <div className="flex justify-between">
                <span className="text-black">
                  DELIVERY SERVICE LEVEL PERFORMANCE
                </span>
              </div>
            </div>
          </div>
          <div className="row" id="perfoma-values">
            <div className="col-12 col-sm-12 col-md-12 col-lg-3 mb-3 mb-lg-0">
              <span className="text-size-xs">number of shipment</span>
              <br />
              <span className="volume-text-sp">
                {delivery ? formatNumber(delivery.total_awb) : "0"}
              </span>
              <br />
              <span className="text-size-xs">Airwaybill</span>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9">
              <div className="row">
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#4a2618" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-5">
                              <span className="text-white text-size-xs volume-text ml-1">
                                Meet
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {delivery
                                  ? formatPercentage(delivery.percentages_meet)
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-7 text-right">
                              <span className="text-white volume-text-sp mr-1">
                                {delivery
                                  ? formatNumber(delivery.meet_awb)
                                  : "0"}
                              </span>
                              <br />
                              <span className="text-white text-size-xs mr-1">
                                airwaybill
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#517b46" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-5">
                              <span className="text-white text-size-xs volume-text ml-1">
                                Exceed
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {delivery
                                  ? formatPercentage(delivery.percentages_exeed)
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-7 text-right">
                              <span className="text-white volume-text-sp mr-1">
                                {delivery
                                  ? formatNumber(delivery.exeed_awb)
                                  : "0"}
                              </span>
                              <br />
                              <span className="text-white text-size-xs mr-1">
                                airwaybill
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#ffb4b4" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-6">
                              <span className="text-white text-size-xs volume-text ml-1">
                                On Process
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {delivery
                                  ? formatPercentage(
                                      delivery.percentages_onprogress
                                    )
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-6 text-right">
                              <span className="text-black volume-text-sp mr-1">
                                {delivery
                                  ? formatNumber(delivery.onprocess_awb)
                                  : "0"}
                              </span>
                              <br />
                              <span className="text-black text-size-xs mr-1">
                                airwaybill
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2 col-12 col-lg-6">
        <div className="card bg-white p-4" id="DELIVERY-PERFORMANCE">
          {isLoadingPickup && <WidgetSkeleton />}
          <div className="row">
            <div className="col-12 mb-2">
              <div className="flex justify-between">
                <span className="text-black">
                  PICKUP SERVICE LEVEL PERFORMANCE
                </span>
              </div>
            </div>
          </div>
          <div className="row" id="perfoma-values">
            <div className="col-12 col-sm-12 col-md-12 col-lg-3 mb-3 mb-lg-0">
              <span className="text-size-xs">number of shipment</span>
              <br />
              <span className="volume-text-sp">
                {pickup ? formatNumber(pickup.total_awb) : "0"}
              </span>
              <br />
              <span className="text-size-xs">Pickup Order</span>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9">
              <div className="row">
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#4a2618" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-5">
                              <span className="text-white text-size-xs volume-text ml-1">
                                Meet
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {pickup
                                  ? formatPercentage(pickup.percentages_meet)
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-7 text-right">
                              <span className="text-white volume-text-sp mr-1">
                                {pickup ? formatNumber(pickup.meet_awb) : "0"}
                              </span>
                              <br />
                              <span className="text-white text-size-xs mr-1">
                                pickup order
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#517b46" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-5">
                              <span className="text-white text-size-xs volume-text ml-1">
                                Exceed
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {pickup
                                  ? formatPercentage(pickup.percentages_exeed)
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-7 text-right">
                              <span className="text-white volume-text-sp mr-1">
                                {pickup ? formatNumber(pickup.exeed_awb) : "0"}
                              </span>
                              <br />
                              <span className="text-white text-size-xs mr-1">
                                pickup order
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                  <a className="detail-push-date" href="" target="_blank">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="card w-100 h-140"
                          style={{ backgroundColor: "#ffb4b4" }}
                        >
                          <div className="row g-0 h-100">
                            <div className="col-6">
                              <span className="text-white text-size-xs volume-text ml-1">
                                On Process
                              </span>
                              <br />
                              <span className="text-white volume-text-sp ml-1">
                                {pickup
                                  ? formatPercentage(
                                      pickup.percentages_onprogress
                                    )
                                  : "0%"}
                              </span>
                            </div>
                            <div className="col-md-6 text-right">
                              <span className="text-black volume-text-sp mr-1">
                                {pickup
                                  ? formatNumber(pickup.onprocess_awb)
                                  : "0"}
                              </span>
                              <br />
                              <span className="text-black text-size-xs mr-1">
                                pickup order
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section5;
